import _ from 'lodash';
import { AnyAction } from 'redux';
import { singleEntityDefaultState, SingleEntityState } from '../entities/types/SingleEntityState';
import {
    FAILURE_CREATE_NEW_EVENT_ADMIN,
    FAILURE_CREATE_NEW_EVENT_COMMISSION_MODEL_ADMIN,
    FAILURE_CREATE_NEW_EVENT_LOCATION_ADMIN,
    FAILURE_CREATE_NEW_EVENT_PARTICIPANT_ADMIN,
    FAILURE_CREATE_NEW_EVENT_TYPE_ADMIN,
    FAILURE_DEACTIVATE_EVENT_COMMISSION_MODEL_ADMIN,
    FAILURE_DEACTIVATE_EVENT_LANGUAGE_COUNTRY_MODEL_ADMIN,
    FAILURE_DEACTIVATE_EVENT_LOCATION_ADMIN,
    FAILURE_DEACTIVATE_EVENT_TYPE_ADMIN,
    FAILURE_DELETE_EVENT_ADMIN,
    FAILURE_DELETE_EVENT_PARTICIPANT_ADMIN,
    FAILURE_EVENTS_ADMIN,
    FAILURE_EVENT_COMMISSION_MODELS_ADMIN,
    FAILURE_EVENT_LANGUAGE_COUNTRY_MODELS_ADMIN,
    FAILURE_EVENT_LOCATIONS_ADMIN,
    FAILURE_EVENT_PARTICIPANTS_ADMIN,
    FAILURE_EVENT_TYPES_ADMIN,
    FAILURE_UPDATE_EVENT_ADMIN,
    FAILURE_UPDATE_EVENT_COMMISSION_MODEL_ADMIN,
    FAILURE_UPDATE_EVENT_LOCATION_ADMIN,
    FAILURE_UPDATE_EVENT_PARTICIPANT_ADMIN,
    FAILURE_UPDATE_EVENT_TYPE_ADMIN,
    REQUEST_CREATE_NEW_EVENT_ADMIN,
    REQUEST_CREATE_NEW_EVENT_COMMISSION_MODEL_ADMIN,
    REQUEST_CREATE_NEW_EVENT_LOCATION_ADMIN,
    REQUEST_CREATE_NEW_EVENT_PARTICIPANT_ADMIN,
    REQUEST_CREATE_NEW_EVENT_TYPE_ADMIN,
    REQUEST_DEACTIVATE_EVENT_COMMISSION_MODEL_ADMIN,
    REQUEST_DEACTIVATE_EVENT_LANGUAGE_COUNTRY_MODEL_ADMIN,
    REQUEST_DEACTIVATE_EVENT_LOCATION_ADMIN,
    REQUEST_DEACTIVATE_EVENT_TYPE_ADMIN,
    REQUEST_DELETE_EVENT_ADMIN,
    REQUEST_DELETE_EVENT_PARTICIPANT_ADMIN,
    REQUEST_EVENTS_ADMIN,
    REQUEST_EVENT_COMMISSION_MODELS_ADMIN,
    REQUEST_EVENT_LANGUAGE_COUNTRY_MODELS_ADMIN,
    REQUEST_EVENT_LOCATIONS_ADMIN,
    REQUEST_EVENT_PARTICIPANTS_ADMIN,
    REQUEST_EVENT_TYPES_ADMIN,
    REQUEST_UPDATE_EVENT_ADMIN,
    REQUEST_UPDATE_EVENT_COMMISSION_MODEL_ADMIN,
    REQUEST_UPDATE_EVENT_LOCATION_ADMIN,
    REQUEST_UPDATE_EVENT_PARTICIPANT_ADMIN,
    REQUEST_UPDATE_EVENT_TYPE_ADMIN,
    SUCCESS_CREATE_NEW_EVENT_ADMIN,
    SUCCESS_CREATE_NEW_EVENT_COMMISSION_MODEL_ADMIN,
    SUCCESS_CREATE_NEW_EVENT_LOCATION_ADMIN,
    SUCCESS_CREATE_NEW_EVENT_PARTICIPANT_ADMIN,
    SUCCESS_CREATE_NEW_EVENT_TYPE_ADMIN,
    SUCCESS_DEACTIVATE_EVENT_COMMISSION_MODEL_ADMIN,
    SUCCESS_DEACTIVATE_EVENT_LANGUAGE_COUNTRY_MODEL_ADMIN,
    SUCCESS_DEACTIVATE_EVENT_LOCATION_ADMIN,
    SUCCESS_DEACTIVATE_EVENT_TYPE_ADMIN,
    SUCCESS_DELETE_EVENT_ADMIN,
    SUCCESS_DELETE_EVENT_PARTICIPANT_ADMIN,
    SUCCESS_EVENTS_ADMIN,
    SUCCESS_EVENT_COMMISSION_MODELS_ADMIN,
    SUCCESS_EVENT_LANGUAGE_COUNTRY_MODELS_ADMIN,
    SUCCESS_EVENT_LOCATIONS_ADMIN,
    SUCCESS_EVENT_PARTICIPANTS_ADMIN,
    SUCCESS_EVENT_TYPES_ADMIN,
    SUCCESS_UPDATE_EVENT_ADMIN,
    SUCCESS_UPDATE_EVENT_COMMISSION_MODEL_ADMIN,
    SUCCESS_UPDATE_EVENT_LOCATION_ADMIN,
    SUCCESS_UPDATE_EVENT_PARTICIPANT_ADMIN,
    SUCCESS_UPDATE_EVENT_TYPE_ADMIN,
} from './actions';

export function eventsAdminReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_EVENTS_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_EVENTS_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_EVENTS_ADMIN:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_CREATE_NEW_EVENT_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CREATE_NEW_EVENT_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        }
        case FAILURE_CREATE_NEW_EVENT_ADMIN:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_UPDATE_EVENT_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_UPDATE_EVENT_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        }
        case FAILURE_UPDATE_EVENT_ADMIN:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_DELETE_EVENT_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_DELETE_EVENT_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        }
        case FAILURE_DELETE_EVENT_ADMIN:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}

export function eventCommissionModelReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_EVENT_COMMISSION_MODELS_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_EVENT_COMMISSION_MODELS_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_EVENT_COMMISSION_MODELS_ADMIN:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_CREATE_NEW_EVENT_COMMISSION_MODEL_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CREATE_NEW_EVENT_COMMISSION_MODEL_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        }
        case FAILURE_CREATE_NEW_EVENT_COMMISSION_MODEL_ADMIN:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_UPDATE_EVENT_COMMISSION_MODEL_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_UPDATE_EVENT_COMMISSION_MODEL_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        }
        case FAILURE_UPDATE_EVENT_COMMISSION_MODEL_ADMIN:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_DEACTIVATE_EVENT_COMMISSION_MODEL_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_DEACTIVATE_EVENT_COMMISSION_MODEL_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        }
        case FAILURE_DEACTIVATE_EVENT_COMMISSION_MODEL_ADMIN:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}

export function eventLocationsReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_EVENT_LOCATIONS_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_EVENT_LOCATIONS_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_EVENT_LOCATIONS_ADMIN:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_CREATE_NEW_EVENT_LOCATION_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CREATE_NEW_EVENT_LOCATION_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        }
        case FAILURE_CREATE_NEW_EVENT_LOCATION_ADMIN:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_UPDATE_EVENT_LOCATION_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_UPDATE_EVENT_LOCATION_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        }
        case FAILURE_UPDATE_EVENT_LOCATION_ADMIN:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_DEACTIVATE_EVENT_LOCATION_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_DEACTIVATE_EVENT_LOCATION_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        }
        case FAILURE_DEACTIVATE_EVENT_LOCATION_ADMIN:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}

export function eventLanguageCountryModelReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_EVENT_LANGUAGE_COUNTRY_MODELS_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_EVENT_LANGUAGE_COUNTRY_MODELS_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_EVENT_LANGUAGE_COUNTRY_MODELS_ADMIN:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_DEACTIVATE_EVENT_LANGUAGE_COUNTRY_MODEL_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_DEACTIVATE_EVENT_LANGUAGE_COUNTRY_MODEL_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        }
        case FAILURE_DEACTIVATE_EVENT_LANGUAGE_COUNTRY_MODEL_ADMIN:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}

export function eventTypeReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_EVENT_TYPES_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_EVENT_TYPES_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_EVENT_TYPES_ADMIN:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_CREATE_NEW_EVENT_TYPE_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CREATE_NEW_EVENT_TYPE_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        }
        case FAILURE_CREATE_NEW_EVENT_TYPE_ADMIN:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_UPDATE_EVENT_TYPE_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_UPDATE_EVENT_TYPE_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        }
        case FAILURE_UPDATE_EVENT_TYPE_ADMIN:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_DEACTIVATE_EVENT_TYPE_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_DEACTIVATE_EVENT_TYPE_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        }
        case FAILURE_DEACTIVATE_EVENT_TYPE_ADMIN:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}

export function eventParticipantReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_EVENT_PARTICIPANTS_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_EVENT_PARTICIPANTS_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_EVENT_PARTICIPANTS_ADMIN:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_CREATE_NEW_EVENT_PARTICIPANT_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CREATE_NEW_EVENT_PARTICIPANT_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        }
        case FAILURE_CREATE_NEW_EVENT_PARTICIPANT_ADMIN:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_UPDATE_EVENT_PARTICIPANT_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_UPDATE_EVENT_PARTICIPANT_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        }
        case FAILURE_UPDATE_EVENT_PARTICIPANT_ADMIN:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_DELETE_EVENT_PARTICIPANT_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_DELETE_EVENT_PARTICIPANT_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        }
        case FAILURE_DELETE_EVENT_PARTICIPANT_ADMIN:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}
